<template>
  <v-app-bar class="toolbar app-header" app fixed dense :height="headerHeight" padding="0" flat style="max-width: 1440px; margin: 0 auto;">
    <v-navigation-drawer
            v-model="drawer"
            app
            class="show_mobile"
    >
      <v-list dense>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar-nav-icon class="show_mobile" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title class="logo">
      <router-link to="/login">
        <img :src="require('@/assets/logo.svg')" />
      </router-link>
    </v-toolbar-title>
    <v-toolbar-items class="show_desk menus">
    </v-toolbar-items>
    <v-spacer></v-spacer>

    <v-menu class="hidden-md-and-up">
      <v-toolbar-side-icon></v-toolbar-side-icon>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: "SiteHeader",
  data() {
    return {
      image: require("@/assets/logo.svg"),
      drawer: false,
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
    };
  },
  computed: {
    headerHeight() {
      if (this.windowWidth <= 420) return 56;
      if (this.windowWidth <= 768) return 70;
      return 100;
    },
  },
  mounted() {
    this._resizeHandler = () => { this.windowWidth = window.innerWidth; };
    window.addEventListener('resize', this._resizeHandler);
  },
  beforeDestroy() {
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
  },
  components: {}
};
</script>

<style lang="scss">
  @import '@/assets/css/style.scss';
</style>

<style scoped lang="scss">
.f-16 {
  font-size: 16px !important;
}
.login-btn {
  color: #fff !important;
  width: 155px;
  box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13) !important;
  border-radius: 24px !important;
  background-color: #29abe2 !important;
}
/* toolbar header — height controlled by v-app-bar :height prop so v-main
   padding-top stays in sync. Do not force height here with !important. */
.toolbar {
  background: #fff !important;
}
.v-toolbar-title.logo {
  padding: 16px 0 0 52px !important;
}
.v-toolbar-title.logo img {
  height: 58px;
  width: auto;
}
.v-toolbar__items > .v-btn.login-btn {
  height: 48px !important;
  margin-top: 18px;
}
.t-b-theme {
  text-transform: capitalize !important;
}

/* Tablet */
@media (max-width: 768px) {
  .v-toolbar-title.logo {
    padding: 10px 0 0 20px !important;
  }
  .v-toolbar-title.logo img {
    height: 44px;
  }
  .v-toolbar__items > .v-btn.login-btn {
    margin-top: 10px;
  }
}

/* Phone */
@media (max-width: 420px) {
  .v-toolbar-title.logo {
    padding: 6px 0 0 14px !important;
  }
  .v-toolbar-title.logo img {
    height: 36px;
  }
  .v-toolbar__items > .v-btn.login-btn {
    height: 40px !important;
    margin-top: 7px;
  }
}
</style>
